import api from "api";
import { useMutation } from "react-query";
import { useId } from "utils/hooks";

const useChangePhysician = () => {
  const id = useId();

  return useMutation(({ physician_id }: { physician_id: number }) =>
    api("PUT /patients/{id}", {
      params: [id],
      data: {
        patient_profile_attributes: {
          physician_id,
        },
      } as any,
    })
  );
};

export default useChangePhysician;
